import { RouterProvider, createBrowserRouter } from "react-router-dom";
import WinApp from "./WinPage/WinApp";
import LandingPage from "./LandingPage";

const Routes: React.FC = () => {
  const router = createBrowserRouter([
    {
      path: "*",
      element: <LandingPage />,
    },
    {
      path: "/wins",
      element: <WinApp />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
};

export default Routes;
